export enum OrdersAlerts {
    CREATED_NEW_ORDER = "Pomyślnie stworzono nowe zamówienie",
    EDITED_ORDER = "Pomyślnie edytowano zamówienie",
    FILL_ALL_FILEDS = "Wypełnij wszystkie wymagane pola"
}